export default __webpack_public_path__ + "static/dismoi-screenshot-le-même-en-local-mounted-website-mobile-4989e619099580e14bfcce2ff8d4d889.jpg";